module.exports = __webpack_public_path__ + "img/gastro-mobile.17423f50.jpg";